import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timi-client-container" }
const _hoisted_2 = { class: "timi-client-detail-content" }
const _hoisted_3 = { class: "timi-detail-column column-33" }
const _hoisted_4 = { class: "ww-data-list-item" }
const _hoisted_5 = { class: "ww-data-list-item" }
const _hoisted_6 = { class: "ww-data-list-item" }
const _hoisted_7 = { class: "ww-card-actions" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_9 = { class: "list-item-small-text" }
const _hoisted_10 = { class: "ww-data-list-item bold" }
const _hoisted_11 = { class: "list-item-small-text" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "list-item-small-text" }
const _hoisted_15 = { class: "ww-data-list-item bold" }
const _hoisted_16 = { class: "list-item-small-text" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "ww-data-list-item bold" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "timi-detail-column column-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          title: _ctx.$t('client.generalData'),
          contentLoading: !_ctx.client.uid
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DataList, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.name')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.client.custName), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.clientNumber')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.client.number ? _ctx.client.number : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.active')), 1),
                  _createVNode(_component_Switch, {
                    class: "active-switch",
                    mini: true,
                    name: "formMode",
                    onOnChange: _ctx.handleToggleActiveClient,
                    value: _ctx.client.active
                  }, null, 8, ["onOnChange", "value"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_8,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleConfirmDeleteClient
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "contentLoading"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('client.timeByActivities'),
          contentLoading: !_ctx.timeEntries
        }, {
          default: _withCtx(() => [
            (_ctx.timeEntries && _ctx.timeEntries.length >0)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesByActivity, (work) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: work.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("h4", null, _toDisplayString(work.title), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.convertTime(work.timeGone)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getTotalTime), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title", "contentLoading"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('client.timeByProjects'),
          contentLoading: !_ctx.timeEntries
        }, {
          default: _withCtx(() => [
            (_ctx.projects && _ctx.projects.length >0)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesByProject, (project) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: project.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("h4", null, [
                          _createElementVNode("a", {
                            href: '/project/detail/' + project.uid
                          }, _toDisplayString(project.title), 9, _hoisted_13)
                        ]),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.convertTime(project.timeGone)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getTotalTime), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title", "contentLoading"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('label.employee')
        }, {
          default: _withCtx(() => [
            (_ctx.timesByEmployee.length)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesByEmployee, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(item.time)), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.totalTime')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.convertSecondsToHours(_ctx.totalTimeByEmployee)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('emptyState.default')), 1))
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.timeEntries.length)
          ? (_openBlock(), _createBlock(_component_Table, {
              key: 0,
              tableData: _ctx.entriesTableData,
              src: _ctx.timeEntries
            }, null, 8, ["tableData", "src"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}